import { render, staticRenderFns } from "./_2.vue?vue&type=template&id=06a1bff8&scoped=true&"
import script from "./_2.vue?vue&type=script&lang=js&"
export * from "./_2.vue?vue&type=script&lang=js&"
import style0 from "./_2.vue?vue&type=style&index=0&id=06a1bff8&prod&lang=scss&scoped=true&"
import style1 from "./_2.vue?vue&type=style&index=1&id=06a1bff8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1bff8",
  null
  
)

export default component.exports